var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#CE4D9C",
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "CE4D9C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m16.7071 10.0069c.3905-.39052.3905-1.02368 0-1.4142-.3905-.39053-1.0237-.39053-1.4142 0l-4.6794 4.6794-1.89318-1.9659c-.38308-.3978-1.01614-.4098-1.41396-.0267s-.40977 1.0161-.02668 1.414l2.6 2.7c.18622.1934.44242.3038.71092.3063.2684.0025.5267-.103.7165-.2929z"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m12 1c-6.07513 0-11 4.92487-11 11 0 6.0751 4.92487 11 11 11 6.0751 0 11-4.9249 11-11 0-6.07513-4.9249-11-11-11zm-9 11c0-4.97056 4.02944-9 9-9 4.9706 0 9 4.02944 9 9 0 4.9706-4.0294 9-9 9-4.97056 0-9-4.0294-9-9z",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.5c2752c3f9224fd886ab12b6c71fb047.svg";
export { ForwardRef as ReactComponent };